import {EDITAR_INFORMACOES, CARREGAR_INFORMACOES_SERVER, CARREGAR_INFORMACOES_STORE} from '../constants/constants';

export const editarInformacoes = (nome='Caminho do Parque', telefones = [], endereco = '') =>({
    type : EDITAR_INFORMACOES, nome, telefones, endereco
})

export const carregarInformacoesDoServer = () =>({
    type : CARREGAR_INFORMACOES_SERVER    
})

window.editarInformacoes = editarInformacoes;
window.carregarInformacoesDoServer = carregarInformacoesDoServer;


// WEBPACK FOOTER //
// ./src/actions/informacoes.js